import {
  PATCH_REASSIGNMENT,
  PATCH_REASSIGNMENT_ERROR,
  PATCH_REASSIGNMENT_SUCCESS,
} from '../../../constants/reassignment';

export const patchReassignmentRed = (state: any, actions: any) => {
  switch (actions.type) {
    case PATCH_REASSIGNMENT:
      return {
        ...state,
        loading: true,
      };
    case PATCH_REASSIGNMENT_ERROR:
      return {
        data: null,
        loading: false,
        error: null,
      };
    case PATCH_REASSIGNMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        data: actions.payload,
      };
    default:
      return state;
  }
};
